import React,{useLayoutEffect,useState} from "react";
import styled from "styled-components";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import CategorySmallCards from "../Cards/CategorySmallCards";


function useWindowSize() {
  const [size, setSize] = useState([0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth]);
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
}

const SwipeToSlide = () => {
    
  const [width] = useWindowSize();
  

    let settings = {
        className: "center",
        infinite: true,
        speed: 100,
        slidesToShow: width<=680 ? 4 :6,
        swipeToSlide: true,
        slidersToScroll: 3,
        centerPadding: "60px",
      };
      return (
        <>
        <div className="lg:px-5 overflow-hidden relative  mx-auto mt-2 lg:mt-4">
        <div className="   lg:pb-5   ">
    
    <Corousel {...settings}>
      <Wrap>
      <CategorySmallCards image={'/images/Home-Kitchen/bluewhite2foldumbrella.jpg'} />
      </Wrap>
      <Wrap>
      <CategorySmallCards image={'/images/Electronics/fire-boldtt-bsw001-smart-watch-with-spo2.jpeg'} />
      </Wrap>
      <Wrap>
      <CategorySmallCards image={'/images/Grocceries/saffola.jpg'}/>
      </Wrap>
      <Wrap>
      <CategorySmallCards image={'/images/Groccery/dairymilk.jpg'}/>
      </Wrap>
      <Wrap>
      <CategorySmallCards image={'/images/Groccery/Homecare.png'}/>
      </Wrap>
      <Wrap>
      <CategorySmallCards image={'/images/Electronics/athotss-black-and-whitenovak-powerful-mixer.jpg'}/>
      </Wrap>
      <Wrap>
      <CategorySmallCards image={'/images/Home-Kitchen/miltonthermosteelbulletflaskwithfliplid750ml.jpg'}/>
      </Wrap>
      <Wrap>
      <CategorySmallCards image={'/images/Electronics/fire-boldtt-bsw001-smart-watch-with-spo2.jpeg'} />
      </Wrap>
    </Corousel>
    </div>
        </div>
          
        </>
      );
    };
    
    const Corousel = styled(Slider)`
      width:100%;
      margin-top: 0px;
      margin:auto;
      padding:20px 20px;
      & > button {
        opacity: 1;
        height: 100%;
        width: 5vw;
        z-index: 1;
        
        &:hover {
         
          
          transition: opacity 0.2s ease 0s;
        }
    
      }
      ul li button {
         &:focuse{
             color:white;
         }
        &:before {
          font-size: 10px;
          color:black;
        }
      }
    
      .slick-list {
        @media(max-width:768px){
          overflow: initial;
        }
        
      }
      .slick-prev {
        left: -20px;
        background-color:black;
        opacity:1;
        width:25px;
        height:90%;
        
        @media(max-width:768px){
          width:0px;
        }
      }
      .slick-next {
        right: -20px;
        background-color:black;
        opacity:1;
        width:25px;
        @media(max-width:768px){
          width:0px;
        }
        height:90%;
        // border-radius:50% 50%;
       
      }
    `;
    
    const Wrap = styled.div`
    border-radius:4px;
    
    position:relative;
    width:70%:
    overflow:hidden;
    `;    

export default SwipeToSlide;